import { render, staticRenderFns } from "./InspectionRecordPointDrawer.vue?vue&type=template&id=2158fe4c&scoped=true&"
import script from "./InspectionRecordPointDrawer.vue?vue&type=script&lang=js&"
export * from "./InspectionRecordPointDrawer.vue?vue&type=script&lang=js&"
import style0 from "./InspectionRecordPointDrawer.vue?vue&type=style&index=0&id=2158fe4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2158fe4c",
  null
  
)

export default component.exports